import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import PhysicianProfileSidebar from "../Components/PhysicianProfileSidebar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import { profileimg, sorry } from "../Constant/Index";
import { useSelector } from "react-redux";
import { getPhysicianviewnoteapi } from "../network/Network";

const PhysicianNotes = () => {
	const token = useSelector((state) => state?.Auth?.token);
	const allphysician = useSelector((state) => state?.Auth?.physiciandetail);
	const [getUsernotes, setGetUsernotes] = useState("");

	//    Get PhysicianNotes Api
	useEffect(() => {
		getPhysicianviewnoteapi(
			allphysician?.booking_detail?.booking_id,
			token,
		).then((res) => {
			setGetUsernotes(res?.data);
		});
	}, []);

	console.log(getUsernotes, "daskasdj");
	//   =====================
	return (
		<>
			<Header />
			<PageHeader pagename="Physician Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<PhysicianProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	gap-3 mb-3">
									<div className="edit-btn back">
										<Link
											to={`/physician-consultation-detail/${allphysician?.booking_detail?.booking_id}`}
										>
											<div className="nav-anchor">
												<i className="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									<h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
										Notes
									</h5>
								</div>
								<div className="row">
									<div className="col-lg-12">
										<div className="content-qty extra-bg-14 radius-20 p-4 dark-color ">
											<div className="d-flex gap-3 align-items-center">
												<img
													src={getUsernotes?.patient_detail?.profile_image_url}
													className="img-fluid profie_img"
													alt=""
												/>

												<div>
													<h4 className="main-heading-font level-6 ">
														{getUsernotes?.patient_detail?.title}
													</h4>
													<h5 className="primary-medium-font level-8 extra-color-15">
														Patient
													</h5>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="row mt-3">
									<div className="col-lg-12">
										<div className="content-qty extra-bg-14 radius-20 p-4 dark-color">
											<h4 className="main-heading-font level-6 ">Notes</h4>
											{getUsernotes?.note ? (
												<p className="extra-color-16">
													{getUsernotes?.note?.note}
												</p>
											) : (
												<h4 className="main-heading-font level-6 ">
													Not Found
												</h4>
											)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default PhysicianNotes;
